/**
 * Complete Parameter Registry
 * Extracted from parameters.md - ALL 479+ parameters
 * This is the authoritative source for parameter keys and display names
 */

export const COMPLETE_PARAMETER_REGISTRY = {
  // Vitals (15 parameters)
  'vitals_temp_c': 'Temperature (°C)',
  'vitals_sbp': 'Systolic Blood Pressure (mmHg)',
  'vitals_dbp': 'Diastolic Blood Pressure (mmHg)',
  'vitals_rhr': 'Resting Heart Rate (bpm)',
  'vitals_rr': 'Respiratory Rate (breaths/min)',
  'vitals_map': 'Mean Arterial Pressure (mmHg)',
  'vitals_pp': 'Pulse Pressure (mmHg)',
  'vitals_spo2': 'Oxygen Saturation (%)',
  'vitals_sirs': 'SIRS Score',
  'vitals_hrv': 'Heart Rate Variability (ms)',
  'vitals_vo2max': 'VO₂ Max (mL/kg/min)',
  'vitals_pain': 'Pain Scale (0-10)',
  'vitals_weight': 'Weight (kg)',
  'vitals_height': 'Height (cm)',
  'vitals_bmi': 'Body Mass Index (kg/m²)',

  // Biometrics - Cognition (13 parameters)
  'biometrics_cognition_tmtA_time': 'Trail Making Test A - Time (seconds)',
  'biometrics_cognition_tmtA_errors': 'Trail Making Test A - Errors',
  'biometrics_cognition_tmtB_time': 'Trail Making Test B - Time (seconds)',
  'biometrics_cognition_tmtB_errors': 'Trail Making Test B - Errors',
  'biometrics_cognition_wordRecall_immediate1': 'Word Recall - Immediate Trial 1',
  'biometrics_cognition_wordRecall_immediate2': 'Word Recall - Immediate Trial 2',
  'biometrics_cognition_wordRecall_delayed': 'Word Recall - Delayed',
  'biometrics_cognition_stroop_word_time': 'Stroop Test - Word Time (seconds)',
  'biometrics_cognition_stroop_word_errors': 'Stroop Test - Word Errors',
  'biometrics_cognition_stroop_color_time': 'Stroop Test - Color Time (seconds)',
  'biometrics_cognition_stroop_color_errors': 'Stroop Test - Color Errors',
  'biometrics_cognition_stroop_incongruent_time': 'Stroop Test - Incongruent Time (seconds)',
  'biometrics_cognition_stroop_incongruent_errors': 'Stroop Test - Incongruent Errors',
  'biometrics_cognition_stroop_interference_time': 'Stroop Test - Interference Time (seconds)',
  'biometrics_cognition_stroop_interference_errors': 'Stroop Test - Interference Errors',

  // Biometrics - Vision (8 parameters)
  'biometrics_vision_visualAcuity_distance_right': 'Visual Acuity - Distance Right Eye',
  'biometrics_vision_visualAcuity_distance_left': 'Visual Acuity - Distance Left Eye',
  'biometrics_vision_visualAcuity_distance_both': 'Visual Acuity - Distance Both Eyes',
  'biometrics_vision_visualAcuity_near_right': 'Visual Acuity - Near Right Eye',
  'biometrics_vision_visualAcuity_near_left': 'Visual Acuity - Near Left Eye',
  'biometrics_vision_visualAcuity_near_both': 'Visual Acuity - Near Both Eyes',
  'biometrics_vision_visualAcuity_pinhole_right': 'Visual Acuity - Pinhole Right Eye',
  'biometrics_vision_visualAcuity_pinhole_left': 'Visual Acuity - Pinhole Left Eye',

  // Biometrics - Pulmonary (9 parameters)
  'biometrics_pulmonary_fev1': 'Forced Expiratory Volume in 1 Second (L)',
  'biometrics_pulmonary_fvc': 'Forced Vital Capacity (L)',
  'biometrics_pulmonary_pefr': 'Peak Expiratory Flow Rate (L/min)',
  'biometrics_pulmonary_fev1_predicted': 'FEV₁ Predicted (%)',
  'biometrics_pulmonary_fef25_75': 'Forced Expiratory Flow 25-75% (L/s)',
  'biometrics_pulmonary_fev1_fvc_ratio': 'FEV₁/FVC Ratio',
  'biometrics_pulmonary_fvc_predicted': 'FVC Predicted (%)',
  'biometrics_pulmonary_pefr_predicted': 'PEFR Predicted (%)',
  'biometrics_pulmonary_lung_age_estimate': 'Lung Age Estimate (years)',

  // Biometrics - Biomeasurement (20 parameters)
  'biometrics_biomeasurement_waistCircumference': 'Waist Circumference (cm)',
  'biometrics_biomeasurement_hipCircumference': 'Hip Circumference (cm)',
  'biometrics_biomeasurement_waistHipRatio': 'Waist-Hip Ratio',
  'biometrics_biomeasurement_neckCircumference': 'Neck Circumference (cm)',
  'biometrics_biomeasurement_weight_inbody': 'InBody Weight (kg)',
  'biometrics_biomeasurement_skeletalMuscleMass': 'Skeletal Muscle Mass (kg)',
  'biometrics_biomeasurement_bodyFatMass': 'Body Fat Mass (kg)',
  'biometrics_biomeasurement_percentBodyFat': 'Body Fat Percentage (%)',
  'biometrics_biomeasurement_visceralFatLevel': 'Visceral Fat Level',




  'biometrics_biomeasurement_softLeanMass': 'Soft Lean Mass (kg)',






  'biometrics_biomeasurement_upperLowerBodyBalance': 'Upper/Lower Body Balance',
  'biometrics_biomeasurement_inbodyScore': 'InBody Score',
  'biometrics_biomeasurement_bodyTypeCoordinate': 'Body Type Coordinate',
  'biometrics_biomeasurement_ree': 'Resting Energy Expenditure (kcal)',
  'biometrics_biomeasurement_tee': 'Total Energy Expenditure (kcal)',

  // Biometrics - Flexibility (3 parameters)
  'biometrics_flexibility_armReach_back_right': 'Back Scratch Test - Right Arm (cm)',
  'biometrics_flexibility_armReach_back_left': 'Back Scratch Test - Left Arm (cm)',
  'biometrics_flexibility_legReach_sitting': 'Sit-and-Reach Test (cm)',

  // Biometrics - Balance (24 parameters)
  'biometrics_balance_ybt_right_anterior_1': 'Y-Balance Test - Right Anterior Trial 1 (cm)',
  'biometrics_balance_ybt_left_anterior_1': 'Y-Balance Test - Left Anterior Trial 1 (cm)',
  'biometrics_balance_ybt_right_posteromedial_1': 'Y-Balance Test - Right Posteromedial Trial 1 (cm)',
  'biometrics_balance_ybt_left_posteromedial_1': 'Y-Balance Test - Left Posteromedial Trial 1 (cm)',
  'biometrics_balance_ybt_right_posterolateral_1': 'Y-Balance Test - Right Posterolateral Trial 1 (cm)',
  'biometrics_balance_ybt_left_posterolateral_1': 'Y-Balance Test - Left Posterolateral Trial 1 (cm)',
  'biometrics_balance_ybt_right_anterior_2': 'Y-Balance Test - Right Anterior Trial 2 (cm)',
  'biometrics_balance_ybt_left_anterior_2': 'Y-Balance Test - Left Anterior Trial 2 (cm)',
  'biometrics_balance_ybt_right_posteromedial_2': 'Y-Balance Test - Right Posteromedial Trial 2 (cm)',
  'biometrics_balance_ybt_left_posteromedial_2': 'Y-Balance Test - Left Posteromedial Trial 2 (cm)',
  'biometrics_balance_ybt_right_posterolateral_2': 'Y-Balance Test - Right Posterolateral Trial 2 (cm)',
  'biometrics_balance_ybt_left_posterolateral_2': 'Y-Balance Test - Left Posterolateral Trial 2 (cm)',
  'biometrics_balance_ybt_right_anterior_avg': 'Y-Balance Test - Right Anterior Average (cm)',
  'biometrics_balance_ybt_left_anterior_avg': 'Y-Balance Test - Left Anterior Average (cm)',
  'biometrics_balance_ybt_right_posteromedial_avg': 'Y-Balance Test - Right Posteromedial Average (cm)',
  'biometrics_balance_ybt_left_posteromedial_avg': 'Y-Balance Test - Left Posteromedial Average (cm)',
  'biometrics_balance_ybt_right_posterolateral_avg': 'Y-Balance Test - Right Posterolateral Average (cm)',
  'biometrics_balance_ybt_left_posterolateral_avg': 'Y-Balance Test - Left Posterolateral Average (cm)',
  'biometrics_balance_ybt_right_limb_length': 'Y-Balance Test - Right Limb Length (cm)',
  'biometrics_balance_ybt_left_limb_length': 'Y-Balance Test - Left Limb Length (cm)',
  'biometrics_balance_ybt_right_composite_reach': 'Y-Balance Test - Right Composite Reach (%)',
  'biometrics_balance_ybt_left_composite_reach': 'Y-Balance Test - Left Composite Reach (%)',
  'biometrics_balance_ybt_composite_deviation': 'Y-Balance Test - Composite Deviation (%)',
  'biometrics_balance_ybt_anterior_deviation': 'Y-Balance Test - Anterior Asymmetry (%)',
  'biometrics_balance_ybt_posteromedial_deviation': 'Y-Balance Test - Posteromedial Asymmetry (%)',
  'biometrics_balance_ybt_posterolateral_deviation': 'Y-Balance Test - Posterolateral Asymmetry (%)',

  // Biometrics - Strength (9 parameters)
  'biometrics_strength_handgrip_right_1': 'Handgrip Strength - Right Trial 1 (kg)',
  'biometrics_strength_handgrip_right_2': 'Handgrip Strength - Right Trial 2 (kg)',
  'biometrics_strength_handgrip_left_1': 'Handgrip Strength - Left Trial 1 (kg)',
  'biometrics_strength_handgrip_left_2': 'Handgrip Strength - Left Trial 2 (kg)',
  'biometrics_strength_handgrip_right_avg': 'Handgrip Strength - Right Average (kg)',
  'biometrics_strength_handgrip_left_avg': 'Handgrip Strength - Left Average (kg)',
  'biometrics_strength_handgrip_normative_status': 'Handgrip Strength - Normative Status',
  'biometrics_strength_handgrip_deviation_percent': 'Handgrip Strength - Deviation (%)',
  'biometrics_strength_handgrip_relative_strength': 'Handgrip Strength - Relative (kg/kg body weight)',
  'biometrics_strength_pushups_completed': 'Push-ups Completed',

  // Biometrics - Endurance (6 parameters)
  'biometrics_endurance_wallsit_duration': 'Wall Sit Duration (seconds)',
  'biometrics_endurance_pushups_completed': 'Push-ups Completed',
  'biometrics_endurance_step_test_duration': 'Step Test Duration (minutes)',
  'biometrics_endurance_heart_rate_peak': 'Peak Heart Rate (bpm)',
  'biometrics_endurance_heart_rate_1min': 'Heart Rate at 1 Minute (bpm)',
  'biometrics_endurance_heart_rate_1min_post_exercise': 'Heart Rate 1 Min Post-Exercise (bpm)',

  // Biometrics - Power (6 parameters)
  'biometrics_power_jump_best': 'Vertical Jump - Best (cm)',
  'biometrics_power_jump_percent_max': 'Vertical Jump - Percent Max (%)',
  'biometrics_power_jump_average_height': 'Vertical Jump - Average Height (cm)',
  'biometrics_power_landing_impact': 'Landing Impact Force (N)',
  'biometrics_power_power_watts': 'Power Output (watts)',

  // Physical Exam - Integumentary (12 parameters)
  'pe_integumentary_alopecia': 'Alopecia (Hair Loss)',
  'pe_integumentary_scalp_lesions': 'Scalp Lesions',
  'pe_integumentary_arm_lesions': 'Arm Lesions',
  'pe_integumentary_leg_lesions': 'Leg Lesions',
  'pe_integumentary_finger_nails': 'Finger Nails',
  'pe_integumentary_toe_nails': 'Toe Nails',
  'pe_integumentary_skin_turgor': 'Skin Turgor',
  'pe_integumentary_jaundice': 'Jaundice',
  'pe_integumentary_pallor': 'Pallor',
  'pe_integumentary_bruising': 'Bruising',
  'pe_integumentary_surgical_scar': 'Surgical Scar',
  'pe_integumentary_caput_medusa': 'Caput Medusae',

  // Physical Exam - Lymph Nodes (8 parameters)
  'pe_lymph_occipital_nodes': 'Occipital Lymph Nodes',
  'pe_lymph_periauricular_nodes': 'Periauricular Lymph Nodes',
  'pe_lymph_cervical_nodes': 'Cervical Lymph Nodes',
  'pe_lymph_submental_nodes': 'Submental Lymph Nodes',
  'pe_lymph_submandibular_nodes': 'Submandibular Lymph Nodes',
  'pe_lymph_supraclavicular_nodes': 'Supraclavicular Lymph Nodes',
  'pe_lymph_femoral_nodes': 'Femoral Lymph Nodes',
  'pe_lymph_popliteal_nodes': 'Popliteal Lymph Nodes',

  // Physical Exam - HEENT Eyes (21 parameters)
  'pe_heent_eyes_conjunctiva': 'Conjunctiva',
  'pe_heent_eyes_sclera': 'Sclera',

  'pe_heent_eyes_ocular_shape': 'Ocular Shape',
  'pe_heent_eyes_vision_field': 'Visual Field',
  'pe_heent_eyes_light_reflex': 'Light Reflex',
  'pe_heent_eyes_red_reflex': 'Red Reflex',
  'pe_heent_eyes_h_test': 'H-Test (Extraocular Movements)',
  'pe_heent_eyes_finger_to_nose': 'Finger-to-Nose Test',

  // Physical Exam - HEENT Ears (10 parameters)

  'pe_heent_ears_tympanic_membrane': 'Tympanic Membrane',

  'pe_heent_ears_weber_test': 'Weber Test',
  'pe_heent_ears_rinne_test': 'Rinne Test',



  'pe_heent_ears_external_ear_canal': 'External Ear Canal',
  'pe_heent_ears_whisper_test': 'Whisper Test',

  // Physical Exam - HEENT Nose (11 parameters)

  'pe_heent_nose_nasal_turbinate': 'Nasal Turbinate',
  'pe_heent_nose_nasal_polyp': 'Nasal Polyp',
  'pe_heent_nose_nasal_septum_deviation': 'Nasal Septum Deviation',
  'pe_heent_nose_maxillary_sinus': 'Maxillary Sinus',
  'pe_heent_nose_frontal_sinus': 'Frontal Sinus',

  // Physical Exam - HEENT Mouth (12 parameters)
  'pe_heent_mouth_oral_mucosa': 'Oral Mucosa',
  'pe_heent_mouth_san_mieng': 'Gingiva',
  'pe_heent_mouth_vom_mieng': 'Palate',
  'pe_heent_mouth_luoi': 'Tongue',
  'pe_heent_mouth_amidan': 'Tonsils',
  'pe_heent_mouth_mallampati': 'Mallampati Score',
  'pe_heent_mouth_uvula_position': 'Uvula Position',
  'pe_heent_mouth_tmj_tenderness': 'TMJ Tenderness',
  'pe_heent_mouth_maxillary_teeth': 'Maxillary Teeth',
  'pe_heent_mouth_mandibular_teeth': 'Mandibular Teeth',
  'pe_heent_mouth_cough_reflex': 'Cough Reflex',


  // Physical Exam - Neck (1 parameter)
  'pe_neck_thyroid': 'Thyroid',

  // Physical Exam - Chest/Respiratory (11 parameters)

  'pe_chest_resp_chest_expansion_symmetry': 'Chest Expansion Symmetry',
  'pe_chest_resp_chest_expansion_range': 'Chest Expansion Range',
  'pe_chest_resp_crackles': 'Crackles',
  'pe_chest_resp_wheezing': 'Wheezing',
  'pe_chest_resp_rhonchi': 'Rhonchi',
  'pe_chest_resp_stridor': 'Stridor',

  // Physical Exam - Cardiovascular (14 parameters)
  'pe_cardio_heart_rhythm': 'Heart Rhythm',
  'pe_cardio_s1': 'S1 Heart Sound',
  'pe_cardio_s2': 'S2 Heart Sound',
  'pe_cardio_s3': 'S3 Heart Sound',
  'pe_cardio_s4': 'S4 Heart Sound',
  'pe_cardio_systolic_murmur': 'Systolic Murmur',
  'pe_cardio_diastolic_murmur': 'Diastolic Murmur',
  'pe_cardio_apical_impulse': 'Apical Impulse',
  'pe_cardio_carotid_bruit': 'Carotid Bruit',
  'pe_cardio_hepatojugular_reflux': 'Hepatojugular Reflux',
  'pe_cardio_radial_pulse': 'Radial Pulse',
  'pe_cardio_cap_refill_finger': 'Capillary Refill - Finger',
  'pe_cardio_abdominal_bruit': 'Abdominal Bruit',
  'pe_cardio_posterior_tibial': 'Posterior Tibial Pulse',

  // Physical Exam - Abdomen (11 parameters)
  'pe_abdomen_bowel_sound': 'Bowel Sounds',
  'pe_abdomen_abdominal_distension': 'Abdominal Distension',
  'pe_abdomen_hepatomegaly': 'Hepatomegaly',
  'pe_abdomen_splenomegaly': 'Splenomegaly',
  'pe_abdomen_epigastric_tenderness': 'Epigastric Tenderness',
  'pe_abdomen_luq_tenderness': 'Left Upper Quadrant Tenderness',
  'pe_abdomen_ruq_tenderness': 'Right Upper Quadrant Tenderness',
  'pe_abdomen_llq_tenderness': 'Left Lower Quadrant Tenderness',
  'pe_abdomen_rlq_tenderness': 'Right Lower Quadrant Tenderness',
  'pe_abdomen_suprapubic_tenderness': 'Suprapubic Tenderness',
  'pe_abdomen_cva_tenderness': 'Costovertebral Angle Tenderness',

  // Physical Exam - Cardiovascular (18 parameters)
  'pe_cardio_dorsalis_pedis': 'Dorsalis Pedis Pulse',
  'pe_cardio_pedal_edema': 'Pedal Edema',
  'pe_cardio_cap_refill_toe': 'Capillary Refill - Toe',
  'pe_cardio_varicose_veins': 'Varicose Veins',

  // Physical Exam - Musculoskeletal (19 parameters)
  'pe_msk_cervical_lordosis': 'Cervical Lordosis',
  'pe_msk_thoracic_kyphosis': 'Thoracic Kyphosis',
  'pe_msk_lumbar_lordosis': 'Lumbar Lordosis',
  'pe_msk_visible_scoliosis': 'Visible Scoliosis',
  'pe_msk_cervical_tenderness': 'Cervical Tenderness',
  'pe_msk_thoracic_tenderness': 'Thoracic Tenderness',
  'pe_msk_lumbar_tenderness': 'Lumbar Tenderness',
  'pe_msk_cervical_flexion': 'Cervical Flexion',
  'pe_msk_cervical_extension': 'Cervical Extension',
  'pe_msk_cervical_rotation': 'Cervical Rotation',
  'pe_msk_lumbar_flexion': 'Lumbar Flexion',
  'pe_msk_lumbar_extension': 'Lumbar Extension',
  'pe_msk_shoulder_height_symmetry': 'Shoulder Height Symmetry',
  'pe_msk_shoulder_abduction_arom': 'Shoulder Abduction AROM',
  'pe_msk_hip_height_symmetry': 'Hip Height Symmetry',
  'pe_msk_thomas_hip_test': 'Thomas Hip Test',
  'pe_msk_faber_test': 'FABER Test',
  'pe_msk_knee_alignment': 'Knee Alignment',
  'pe_msk_patellar_reflex': 'Patellar Reflex',

  // Physical Exam - Neurological (6 parameters)
  'pe_neuro_ulnar_nerve_sensory': 'Ulnar Nerve Sensory',
  'pe_neuro_radial_nerve_sensory': 'Radial Nerve Sensory',
  'pe_neuro_medial_nerve_sensory': 'Median Nerve Sensory',
  'pe_neuro_pinprick_sensory': 'Pinprick Sensory',
  'pe_neuro_tandem_walk': 'Tandem Walk',
  'pe_neuro_romberg': 'Romberg Test',

  // Imaging - Spleen US (6 parameters)
  'imaging_spleen_us_craniocaudal_length': 'Spleen Craniocaudal Length (cm)',
  'imaging_spleen_us_capsular_edge_nodularity': 'Spleen Capsular Edge Nodularity',
  'imaging_spleen_us_parenchymal_echogenicity': 'Spleen Parenchymal Echogenicity',
  'imaging_spleen_us_largest_lesion_diameter': 'Spleen Largest Lesion Diameter (cm)',
  'imaging_spleen_us_splenic_vein_diameter': 'Splenic Vein Diameter (mm)',
  'imaging_spleen_us_psdr': 'Portal Splenic Diameter Ratio',

  // Imaging - Liver US (7 parameters)
  'imaging_liver_us_craniocaudal_length': 'Liver Craniocaudal Length (cm)',
  'imaging_liver_us_capsular_edge_nodularity': 'Liver Capsular Edge Nodularity',
  'imaging_liver_us_echogenicity_steatosis': 'Liver Echogenicity/Steatosis',
  'imaging_liver_us_portal_vein_diameter': 'Portal Vein Diameter (mm)',
  'imaging_liver_us_lirads': 'LI-RADS Score',
  'imaging_liver_us_largest_lesion_diameter': 'Liver Largest Lesion Diameter (cm)',
  'imaging_liver_us_hepatic_vein_waveform': 'Hepatic Vein Waveform',

  // Imaging - Carotid US (17 parameters)
  'imaging_carotid_us_l_cca_score': 'Left Common Carotid Artery Score',
  'imaging_carotid_us_r_cca_score': 'Right Common Carotid Artery Score',
  'imaging_carotid_us_l_bulb_score': 'Left Carotid Bulb Score',
  'imaging_carotid_us_r_bulb_score': 'Right Carotid Bulb Score',
  'imaging_carotid_us_l_ica_score': 'Left Internal Carotid Artery Score',
  'imaging_carotid_us_r_ica_score': 'Right Internal Carotid Artery Score',
  'imaging_carotid_us_l_cimt': 'Left Carotid Intima-Media Thickness (mm)',
  'imaging_carotid_us_r_cimt': 'Right Carotid Intima-Media Thickness (mm)',
  'imaging_carotid_us_plaque_presence': 'Carotid Plaque Presence',
  'imaging_carotid_us_surface_ulceration': 'Carotid Surface Ulceration',
  'imaging_carotid_us_calcification_pattern': 'Carotid Calcification Pattern',
  'imaging_carotid_us_l_ica_psv': 'Left ICA Peak Systolic Velocity (cm/s)',
  'imaging_carotid_us_r_ica_psv': 'Right ICA Peak Systolic Velocity (cm/s)',
  'imaging_carotid_us_l_ica_edv': 'Left ICA End Diastolic Velocity (cm/s)',
  'imaging_carotid_us_r_ica_edv': 'Right ICA End Diastolic Velocity (cm/s)',
  'imaging_carotid_us_vascular_age_imt': 'Vascular Age by IMT (years)',
  'imaging_carotid_us_vascular_age_cac': 'Vascular Age by CAC (years)',

  // Imaging - EKG (10 parameters)
  'imaging_ekg_rhythm_abnormality': 'EKG Rhythm Abnormality',
  'imaging_ekg_axis_deviation': 'EKG Axis Deviation',
  'imaging_ekg_ventricular_hypertrophy': 'EKG Ventricular Hypertrophy',
  'imaging_ekg_conduction_abnormality': 'EKG Conduction Abnormality',
  'imaging_ekg_pr_interval': 'EKG PR Interval (ms)',
  'imaging_ekg_qrs_duration': 'EKG QRS Duration (ms)',
  'imaging_ekg_qtc_interval': 'EKG QTc Interval (ms)',
  'imaging_ekg_st_changes': 'EKG ST Changes',
  'imaging_ekg_t_wave_interval': 'EKG T Wave Changes',
  'imaging_ekg_ectopy': 'EKG Ectopy',

  // Imaging - Bladder US (8 parameters)
  'imaging_bladder_us_pre_void_volume': 'Bladder Pre-Void Volume (mL)',
  'imaging_bladder_us_pvr_volume': 'Bladder Post-Void Residual Volume (mL)',
  'imaging_bladder_us_wall_thickness': 'Bladder Wall Thickness (mm)',
  'imaging_bladder_us_calculi_presence': 'Bladder Calculi Presence',
  'imaging_bladder_us_calculi_description': 'Bladder Calculi Description',
  'imaging_bladder_us_masses_presence': 'Bladder Masses Presence',
  'imaging_bladder_us_masses_description': 'Bladder Masses Description',
  'imaging_bladder_us_ureteral_jets': 'Ureteral Jets',

  // Imaging - Chest XR (14 parameters)
  'imaging_chest_xr_date': 'Chest X-Ray Date',
  'imaging_chest_xr_pleural_effusion': 'Pleural Effusion',
  'imaging_chest_xr_enlarged_pulmonary_artery': 'Enlarged Pulmonary Artery',
  'imaging_chest_xr_enlarged_right_ventricle': 'Enlarged Right Ventricle',
  'imaging_chest_xr_flattened_diaphragm': 'Flattened Diaphragm',
  'imaging_chest_xr_cardiothoracic_ratio_gt_50': 'Cardiothoracic Ratio >50%',
  'imaging_chest_xr_cavitary_lung_lesion': 'Cavitary Lung Lesion',
  'imaging_chest_xr_widened_mediastinum': 'Widened Mediastinum',
  'imaging_chest_xr_enlarged_hilar_lymph_nodes': 'Enlarged Hilar Lymph Nodes',
  'imaging_chest_xr_atelectasis': 'Atelectasis',
  'imaging_chest_xr_pulmonary_infiltrates': 'Pulmonary Infiltrates',
  'imaging_chest_xr_pulmonary_nodule_or_mass': 'Pulmonary Nodule or Mass',
  'imaging_chest_xr_spinal_deviation': 'Spinal Deviation',
  'imaging_chest_xr_lytic_bone_lesion': 'Lytic Bone Lesion',

  // Imaging - Heart US (5 parameters)
  'imaging_heart_us_ejection_fraction': 'Ejection Fraction (%)',
  'imaging_heart_us_wall_motion': 'Wall Motion',
  'imaging_heart_us_valve_function': 'Valve Function',
  'imaging_heart_us_chamber_size': 'Chamber Size',
  'imaging_heart_us_pericardial_effusion': 'Pericardial Effusion',

  // Imaging - Gallbladder US (5 parameters)
  'imaging_gallbladder_us_wall_thickness': 'Gallbladder Wall Thickness (mm)',
  'imaging_gallbladder_us_stones_present': 'Gallbladder Stones Present',
  'imaging_gallbladder_us_sludge_present': 'Gallbladder Sludge Present',
  'imaging_gallbladder_us_polyps_present': 'Gallbladder Polyps Present',
  'imaging_gallbladder_us_distension': 'Gallbladder Distension',

  // Imaging - Kidney US (6 parameters)
  'imaging_kidney_us_right_size': 'Right Kidney Size (cm)',
  'imaging_kidney_us_left_size': 'Left Kidney Size (cm)',
  'imaging_kidney_us_echogenicity': 'Kidney Echogenicity',
  'imaging_kidney_us_hydronephrosis': 'Hydronephrosis',
  'imaging_kidney_us_stones_present': 'Kidney Stones Present',
  'imaging_kidney_us_masses_present': 'Kidney Masses Present',

  // Labs - Cardiac (3 parameters)
  'labs_cardiac_troponin': 'Troponin-HS (ng/L)',
  'labs_cardiac_bnp': 'B-Type Natriuretic Peptide (pg/mL)',
  'labs_cardiac_ckmb': 'Creatine Kinase-MB (ng/mL)',

  // Labs - CBC (25 parameters)
  'labs_cbc_wbc': 'White Blood Cell Count (×10³/μL)',
  'labs_cbc_neut': 'Neutrophils (×10³/μL)',
  'labs_cbc_lymph': 'Lymphocytes (×10³/μL)',
  'labs_cbc_mono': 'Monocytes (×10³/μL)',
  'labs_cbc_eos': 'Eosinophils (×10³/μL)',
  'labs_cbc_baso': 'Basophils (×10³/μL)',
  'labs_cbc_neut_pct': 'Neutrophils (%)',
  'labs_cbc_lymph_pct': 'Lymphocytes (%)',
  'labs_cbc_mono_pct': 'Monocytes (%)',
  'labs_cbc_eos_pct': 'Eosinophils (%)',
  'labs_cbc_baso_pct': 'Basophils (%)',
  'labs_cbc_rbc': 'Red Blood Cell Count (×10⁶/μL)',
  'labs_cbc_hgb': 'Hemoglobin (g/dL)',
  'labs_cbc_hct': 'Hematocrit (%)',
  'labs_cbc_mcv': 'Mean Corpuscular Volume (fL)',
  'labs_cbc_mch': 'Mean Corpuscular Hemoglobin (pg)',
  'labs_cbc_mchc': 'Mean Corpuscular Hemoglobin Concentration (g/dL)',
  'labs_cbc_rdw': 'Red Cell Distribution Width (%)',
  'labs_cbc_rdw_sd': 'Red Cell Distribution Width-SD (fL)',
  'labs_cbc_plt': 'Platelet Count (×10³/μL)',
  'labs_cbc_mpv': 'Mean Platelet Volume (fL)',
  'labs_cbc_pdw': 'Platelet Distribution Width (%)',
  'labs_cbc_pct': 'Plateletcrit (%)',
  'labs_cbc_p_lcr': 'Platelet Large Cell Ratio (%)',
  'labs_cbc_nlr': 'Neutrophil-to-Lymphocyte Ratio',

  // Labs - Coagulation (6 parameters)
  'labs_coagulation_pt': 'Prothrombin Time (seconds)',
  'labs_coagulation_inr': 'International Normalized Ratio (INR)',
  'labs_coagulation_ptt': 'Partial Thromboplastin Time (seconds)',
  'labs_coagulation_thrombin_time': 'Thrombin Time (seconds)',
  'labs_coagulation_fibrinogen': 'Fibrinogen (mg/dL / g/L)',
  'labs_coagulation_d_dimer': 'D-Dimer (ng/mL / μg/L)',

  // Labs - Glucose (2 parameters)
  'labs_glucose_hba1c': 'Hemoglobin A1c (HbA1c) (%)',
  'labs_glucose_glucose': 'Glucose (mg/dL / mmol/L)',

  // Labs - Lipids (11 parameters)
  'labs_lipid_apob': 'Apolipoprotein B (mg/dL)',
  'labs_lipid_chol_total': 'Total Cholesterol (mg/dL / mmol/L)',
  'labs_lipid_hdl': 'High-Density Lipoprotein Cholesterol (mg/dL / mmol/L)',
  'labs_lipid_ldl': 'Low-Density Lipoprotein Cholesterol (mg/dL / mmol/L)',
  'labs_lipid_trig': 'Triglycerides (mg/dL / mmol/L)',
  'labs_lipid_vldl': 'Very Low-Density Lipoprotein Cholesterol (mg/dL)',
  'labs_lipid_non_hdl': 'Non-HDL Cholesterol (mg/dL)',
  'labs_lipid_tg_hdl_ratio': 'Triglyceride/HDL Ratio',
  'labs_lipid_tc_glu_ratio': 'Total Cholesterol/Glucose Ratio',
  'labs_lipid_tc_hdl_ratio': 'Total Cholesterol/HDL Ratio',
  'labs_lipid_athero_idx': 'Atherogenic Index',

  // Labs - Electrolytes (9 parameters)
  'labs_electrolytes_magnesium': 'Magnesium (mmol/L / mg/dL)',
  'labs_electrolytes_phosphorous': 'Phosphorus (mmol/L / mg/dL)',
  'labs_electrolytes_sodium': 'Sodium (mmol/L)',
  'labs_electrolytes_potassium': 'Potassium (mmol/L)',
  'labs_electrolytes_chloride': 'Chloride (mmol/L)',
  'labs_electrolytes_calcium': 'Calcium (mmol/L / mg/dL)',
  'labs_electrolytes_bicarb': 'Bicarbonate (mmol/L)',
  'labs_electrolytes_osmolality': 'Osmolality (mOsm/kg)',
  'labs_electrolytes_na_k_ratio': 'Sodium/Potassium Ratio',

  // Labs - Vitamins (5 parameters)
  'labs_vitamins_iron': 'Iron (μg/dL / μmol/L)',
  'labs_vitamins_b12': 'Vitamin B12 (pg/mL / pmol/L)',
  'labs_vitamins_d3': 'Vitamin D3 (ng/mL / nmol/L)',
  'labs_vitamins_b9': 'Folate (Vitamin B9) (ng/mL / nmol/L)',
  'labs_vitamins_ferritin': 'Ferritin (ng/mL / μg/L)',

  // Labs - Renal (4 parameters)
  'labs_renal_creatinine': 'Creatinine (mg/dL / μmol/L)',
  'labs_renal_egfr': 'Estimated Glomerular Filtration Rate (mL/min/1.73m²)',
  'labs_renal_urea': 'Urea (mg/dL / mmol/L)',
  'labs_renal_bun': 'Blood Urea Nitrogen (mg/dL)',

  // Labs - Inflammation (3 parameters)
  'labs_inflammation_uric_acid': 'Uric Acid (mg/dL / μmol/L)',
  'labs_inflammation_hscrp': 'High-Sensitivity C-Reactive Protein (mg/L)',
  'labs_inflammation_esr': 'Erythrocyte Sedimentation Rate (mm/hr)',

  // Labs - Hepatology (7 parameters)
  'labs_hepatology_ast': 'Aspartate Aminotransferase (U/L)',
  'labs_hepatology_alt': 'Alanine Aminotransferase (U/L)',
  'labs_hepatology_ggt': 'Gamma-Glutamyl Transferase (U/L)',
  'labs_hepatology_bili_total': 'Total Bilirubin (mg/dL / μmol/L)',
  'labs_hepatology_bili_direct': 'Direct Bilirubin (mg/dL / μmol/L)',
  'labs_hepatology_bili_indirect': 'Indirect Bilirubin (mg/dL / μmol/L)',
  'labs_hepatology_alp': 'Alkaline Phosphatase (U/L)',

  // Labs - Protein (4 parameters)
  'labs_protein_total': 'Total Protein (g/dL / g/L)',
  'labs_protein_albumin': 'Albumin (g/dL / g/L)',
  'labs_protein_prealbumin': 'Prealbumin (mg/dL / g/L)',
  'labs_protein_alb_glob_ratio': 'Albumin/Globulin Ratio',

  // Labs - Thyroid (3 parameters)
  'labs_thyroid_ft4': 'Free Thyroxine (T4) (ng/dL / pmol/L)',
  'labs_thyroid_tsh': 'Thyroid Stimulating Hormone (μIU/mL / mIU/L)',
  'labs_thyroid_ft3': 'Free Triiodothyronine (T3) (pg/mL / pmol/L)',

  // Labs - Urine (14 parameters)
  'labs_urine_sg': 'Specific Gravity',
  'labs_urine_ph': 'Urine pH',
  'labs_urine_nitrite': 'Nitrite',
  'labs_urine_protein': 'Protein',
  'labs_urine_glucose': 'Glucose',
  'labs_urine_ketones': 'Ketones',
  'labs_urine_urobil': 'Urobilinogen',
  'labs_urine_bili': 'Bilirubin',
  'labs_urine_ery': 'Erythrocytes',
  'labs_urine_leuk': 'Leukocytes',
  'labs_urine_microalb': 'Microalbumin (mg/L)',
  'labs_urine_creat': 'Creatinine (mg/dL)',
  'labs_urine_uacr': 'Urine Albumin-to-Creatinine Ratio (mg/g)',

  // Lifestyle - Nutrition (30 parameters)
  'lifestyle_nutrition_protein_intake': 'Daily Protein Intake',
  'lifestyle_nutrition_fruit_intake': 'Daily Fruit Intake',
  'lifestyle_nutrition_vegetables_intake': 'Daily Vegetable Intake',
  'lifestyle_nutrition_refined_carbs_intake': 'Refined Carbohydrate Intake',
  'lifestyle_nutrition_fiber_intake': 'Daily Fiber Intake',
  'lifestyle_nutrition_seeds_nuts_intake': 'Seeds and Nuts Intake',
  'lifestyle_nutrition_sodium_intake': 'Daily Sodium Intake',
  'lifestyle_nutrition_sugar_intake': 'Daily Sugar Intake',
  'lifestyle_nutrition_fried_food_intake': 'Fried Food Intake',
  'lifestyle_nutrition_healthy_oil_use': 'Healthy Oil Use',
  'lifestyle_nutrition_ultraprocessed_intake': 'Ultra-Processed Food Intake',
  'lifestyle_nutrition_water_intake': 'Daily Water Intake',
  'lifestyle_nutrition_alcohol_intake': 'Alcohol Consumption',
  'lifestyle_nutrition_weight_loss_concern': 'Weight Loss Concern',
  'lifestyle_nutrition_weight_gain_concern': 'Weight Gain Concern',
  'lifestyle_nutrition_appetite_lower_normal': 'Appetite Lower Than Normal',
  'lifestyle_nutrition_appetite_higher_normal': 'Appetite Higher Than Normal',
  'lifestyle_nutrition_skip_meals_hungry': 'Skip Meals When Hungry',
  'lifestyle_nutrition_full_small_amount': 'Feel Full After Small Amount',
  'lifestyle_nutrition_difficulty_chewing_swallowing': 'Difficulty Chewing/Swallowing',
  'lifestyle_nutrition_problems_taste_smell': 'Problems with Taste/Smell',
  'lifestyle_nutrition_worry_food_access': 'Worry About Food Access',
  'lifestyle_nutrition_bored_eating': 'Eating When Bored',
  'lifestyle_nutrition_busy_eating': 'Eating When Busy',
  'lifestyle_nutrition_late_eating': 'Late Night Eating',
  'lifestyle_nutrition_binge_eating': 'Binge Eating',
  'lifestyle_nutrition_guilty_eating': 'Guilty Eating',
  'lifestyle_nutrition_rushed_eating': 'Rushed Eating',
  'lifestyle_nutrition_distracted_eating': 'Distracted Eating',
  'lifestyle_nutrition_eating_behaviors_bored_eating': 'Eating Behavior - Bored Eating',
  'lifestyle_nutrition_eating_behaviors_busy_eating': 'Eating Behavior - Busy Eating',
  'lifestyle_nutrition_eating_behaviors_late_eating': 'Eating Behavior - Late Eating',
  'lifestyle_nutrition_eating_behaviors_binge_eating': 'Eating Behavior - Binge Eating',
  'lifestyle_nutrition_eating_behaviors_guilty_eating': 'Eating Behavior - Guilty Eating',
  'lifestyle_nutrition_eating_behaviors_rushed_eating': 'Eating Behavior - Rushed Eating',
  'lifestyle_nutrition_eating_behaviors_distracted_eating': 'Eating Behavior - Distracted Eating',
  'lifestyle_nutrition_eating_behaviors_fad_diets': 'Eating Behavior - Fad Diets',
  'lifestyle_nutrition_fad_diets': 'Following Fad Diets',

  // Lifestyle - Movement (12 parameters)
  'lifestyle_movement_moderate_activity_days': 'Moderate Activity Days per Week',
  'lifestyle_movement_vigorous_activity_days': 'Vigorous Activity Days per Week',
  'lifestyle_movement_strength_training_days': 'Strength Training Days per Week',
  'lifestyle_movement_flexibility_stretching_days': 'Flexibility/Stretching Days per Week',
  'lifestyle_movement_balance_practice_days': 'Balance Practice Days per Week',
  'lifestyle_movement_incidental_walking_time': 'Incidental Walking Time',
  'lifestyle_movement_sedentary_hours': 'Daily Sedentary Hours',
  'lifestyle_movement_sitting_break_days': 'Sitting Break Days per Week',
  'lifestyle_movement_red_flag_sob': 'Exercise Red Flag - Shortness of Breath',
  'lifestyle_movement_red_flag_chest_pain': 'Exercise Red Flag - Chest Pain',
  'lifestyle_movement_red_flag_palpitations': 'Exercise Red Flag - Palpitations',
  'lifestyle_movement_red_flag_dizziness': 'Exercise Red Flag - Dizziness',
  'lifestyle_movement_red_flag_pain': 'Exercise Red Flag - Pain',
  'lifestyle_movement_red_flag_imbalance': 'Exercise Red Flag - Imbalance',

  // Lifestyle - Recovery (17 parameters)
  'lifestyle_recovery_sleep_quality': 'Sleep Quality Rating',
  'lifestyle_recovery_sleep_duration': 'Sleep Duration (hours)',
  'lifestyle_recovery_sleep_continuity': 'Sleep Continuity Rating',
  'lifestyle_recovery_sleep_onset': 'Sleep Onset Time',
  'lifestyle_recovery_bedtime_consistency': 'Bedtime Consistency',
  'lifestyle_recovery_late_bedtime': 'Late Bedtime Frequency',
  'lifestyle_recovery_sleep_environment_factors_uncomfortable_mattress': 'Sleep Environment - Uncomfortable Mattress',
  'lifestyle_recovery_sleep_environment_factors_room_temperature': 'Sleep Environment - Room Temperature',
  'lifestyle_recovery_sleep_environment_factors_bright_light': 'Sleep Environment - Bright Light',
  'lifestyle_recovery_sleep_environment_factors_loud_noises': 'Sleep Environment - Loud Noises',
  'lifestyle_recovery_sleep_environment_factors_electronic_screens': 'Sleep Environment - Electronic Screens',
  'lifestyle_recovery_sleep_environment_factors_caffeine_stimulants': 'Sleep Environment - Caffeine/Stimulants',
  'lifestyle_recovery_napping_frequency': 'Napping Frequency',
  'lifestyle_recovery_daytime_sleepiness': 'Daytime Sleepiness',
  'lifestyle_recovery_sleep_disorders_waking_drenched_sweats': 'Sleep Disorder - Night Sweats',
  'lifestyle_recovery_sleep_disorders_teeth_grinding': 'Sleep Disorder - Teeth Grinding',
  'lifestyle_recovery_sleep_disorders_nasal_congestion_snoring': 'Sleep Disorder - Snoring/Nasal Congestion',
  'lifestyle_recovery_sleep_disorders_restless_legs': 'Sleep Disorder - Restless Legs',
  'lifestyle_recovery_sleep_disorders_racing_thoughts': 'Sleep Disorder - Racing Thoughts',
  'lifestyle_recovery_sleep_disorders_upsetting_dreams': 'Sleep Disorder - Upsetting Dreams',

  // Lifestyle - Emotion (22 parameters)
  'lifestyle_emotion_little_interest': 'Little Interest in Activities',
  'lifestyle_emotion_feeling_down': 'Feeling Down/Depressed',
  'lifestyle_emotion_feeling_nervous': 'Feeling Nervous/Anxious',
  'lifestyle_emotion_not_being_able': 'Not Being Able to Stop Worrying',
  'lifestyle_emotion_difficulty_concentrating': 'Difficulty Concentrating',
  'lifestyle_emotion_feeling_irritable': 'Feeling Irritable',
  'lifestyle_emotion_felt_unable_control': 'Felt Unable to Control Important Things',
  'lifestyle_emotion_felt_confident_problems': 'Felt Confident About Handling Problems',
  'lifestyle_emotion_felt_things_going_way': 'Felt Things Were Going Your Way',
  'lifestyle_emotion_felt_difficulties_piling_up': 'Felt Difficulties Were Piling Up',
  'lifestyle_emotion_lack_companionship': 'Lack of Companionship',
  'lifestyle_emotion_feel_left_out': 'Feel Left Out',
  'lifestyle_emotion_feel_isolated': 'Feel Isolated',
  'lifestyle_emotion_burnout_emotionally_exhausted': 'Burnout - Emotionally Exhausted',
  'lifestyle_emotion_burnout_cynical': 'Burnout - Cynical',
  'lifestyle_emotion_burnout_cant_disconnect': 'Burnout - Can\'t Disconnect',
  'lifestyle_emotion_burnout_no_breaks': 'Burnout - No Breaks',
  'lifestyle_emotion_burnout_long_hours': 'Burnout - Long Hours',
  'lifestyle_emotion_burnout_personal_time': 'Burnout - Lack of Personal Time',
  'lifestyle_emotion_burnout_family_time': 'Burnout - Lack of Family Time',
  'lifestyle_emotion_burnout_purpose': 'Burnout - Loss of Purpose',

  // Lifestyle - Environment (5 parameters)
  'lifestyle_environment_smoking_quantity_daily': 'Daily Smoking Quantity',
  'lifestyle_environment_smoking_duration_years': 'Smoking Duration (years)',
  'lifestyle_environment_outdoor_daylight_minutes': 'Outdoor Daylight Exposure (minutes)',
  'lifestyle_environment_nature_time_days_weekly': 'Nature Time (days per week)',
  'lifestyle_environment_morning_outdoor_light_days_weekly': 'Morning Outdoor Light (days per week)',
};

/**
 * Helper function to get category from parameter key
 */
export const getCategoryFromKey = (key) => {
  // Add null/undefined check to prevent startsWith errors
  if (!key || typeof key !== 'string') {
    console.warn('getCategoryFromKey: Invalid key provided:', key);
    return 'Other';
  }

  if (key.startsWith('vitals_')) return 'Vitals';
  if (key.startsWith('biometrics_')) return 'Biometrics';
  if (key.startsWith('pe_')) return 'Physical Exam';
  if (key.startsWith('labs_')) return 'Labs';
  if (key.startsWith('imaging_')) return 'Imaging';
  if (key.startsWith('lifestyle_')) return 'Lifestyle';
  return 'Other';
};

/**
 * Helper function to get subcategory from parameter key
 */
export const getSubcategoryFromKey = (key) => {
  const parts = key.split('_');
  if (parts.length >= 3) {
    return parts[1]; // e.g., 'cognition' from 'biometrics_cognition_tmtA_time'
  }
  return '';
};

/**
 * Search function for parameters
 */
export const searchParameters = (parameters, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === '') {
    return parameters;
  }

  const term = searchTerm.toLowerCase().trim();
  
  return parameters.filter(param => {
    // Search in parameter key
    if (param.key.toLowerCase().includes(term)) return true;
    
    // Search in display name
    if (param.displayName.toLowerCase().includes(term)) return true;
    
    // Search in category
    if (param.category && param.category.toLowerCase().includes(term)) return true;
    
    // Search in individual words of display name
    const displayWords = param.displayName.toLowerCase().split(/[\s\-\(\)\/]+/);
    if (displayWords.some(word => word.includes(term))) return true;
    
    return false;
  });
};

export default COMPLETE_PARAMETER_REGISTRY;
